export enum LoginUserModeEnum {
  Owner = 'owner',
  Agent = 'agent',
  Impersonation = 'impersonation',
}

export type LoginUserMode = `${LoginUserModeEnum}`
